import { useEffect, useState } from "react";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import { Button, Container } from "../styles";
import { FormFilter } from "./components/filter/filter";
import { FormValuesSingleCharge, SingleChargeItem, SingleChargeTableData } from "./types";
import LiveTable from "./components/liveTable/liveTable";
import { PlusOutlined } from "@ant-design/icons";
import useCurrentUser from "../../../hooks/useCurrentUser";
import SingleChargeService from "./service/singleChargeService";
import { ModalCadastroSingleCharge } from "./components/modalCadastroSingleCharge/modalCadastroSingleCharge";
import { can, PortalPermissions } from "../../../config/permissions";

const SingleCharge: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState<FormValuesSingleCharge>({});
  const [tableData, setTableData] = useState<SingleChargeTableData>({ records: [], count: 0, });
  const [openModal, setOpenModal] = useState(false);
  const [selectedSingleCharge, setSelectedSingleCharge] = useState<SingleChargeItem | undefined>(undefined);
  const [mode, setMode] = useState<"create" | "edit">("create");
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const singleChargeService = new SingleChargeService();
  const user = useCurrentUser();
  const isAdmin = user?.userType === 3;

  const fetchSingleCharges = async () => {
    setIsLoading(true);

    try {
      const response = await singleChargeService.getSingleCharge(
        currentPage,
        pageSize,
        filterData ?? undefined
      );

      setTableData({
        records: response.data || [],
        count: response.data?.length || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar cobranças avulsas:", error);
      setTableData({
        records: [],
        count: 0,
      });
    } finally {
      setIsLoading(false);
    }
  };


  const handleOpenCreateModal = () => {
    setSelectedSingleCharge(undefined);
    setMode("create");
    setOpenModal(true);
  };

  const handleEdit = (record: SingleChargeItem) => {
    setSelectedSingleCharge(record);
    setMode("edit");
    setOpenModal(true);
  };

  useEffect(() => {
    if (filterData) {
      fetchSingleCharges();
    }
  }, [currentPage, pageSize, filterData]);

  const handleFilters = (data: FormValuesSingleCharge) => {
    setCurrentPage(1);
    setFilterData(data);
  };


  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />
      <T2>Cobrança Pontual</T2>
      {isAdmin && can(PortalPermissions.cobrancas.cobrancaPontual.criar) && (
        <Button
          icon={<PlusOutlined />}
          size="small"
          onClick={handleOpenCreateModal}
          style={{ width: "12rem", height: 32, marginLeft: "auto", display: "block" }}
        >
          Nova Cobrança
        </Button>
      )}
      <FormFilter getFilters={handleFilters} />
      <LiveTable
        data={tableData}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        onEdit={handleEdit}
      />

      <ModalCadastroSingleCharge
        open={openModal}
        onClose={() => setOpenModal(false)}
        mode={mode}
        initialData={selectedSingleCharge}
        onCreate={async (data) => {
          await singleChargeService.createSingleCharge(data);
          await fetchSingleCharges();
        }}
        onUpdate={async (data) => {
          await singleChargeService.updateSingleCharge(data);
          await fetchSingleCharges();
        }}
      />
    </Container>
  );
};

export default SingleCharge;


